<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">{{vibecheck.name}}</div>
				<div class="content">
					<div *ngIf="!checkresults" class="loader">
						<div *ngIf="!error">
							<div class="logo-spin light"></div>
							Loading...
						</div>
						<div *ngIf="error">
							<div class="logo-spin light stopped"></div>
							{{error}}
						</div>
					</div>
					<div *ngIf="checkresults">
						<table class="table-vibecheck">
							<thead>
								<tr>
									<th>Name</th>
									<th>CI Date</th>
									<th>IPS</th>
									<th>Warning Threshold</th>
									<th>Alarm Threshold</th>
								</tr>
							</thead>
							<tbody *ngFor="let row of checkresults">
								<tr>
									<td>{{row.name}}</td>
									<td>{{row.date | datetime : "offset" : asset.time_offset_hours}}</td>
									<td [class.status-ok-fg]="row.value < row.warn" [class.status-warning-fg]="row.value >= row.warn && row.value < row.alarm"
										[class.status-error-fg]="row.value >= row.alarm">{{row.value}}</td>
									<td>{{row.warn}}</td>
									<td>{{row.alarm}}</td>
								</tr>
							</tbody>
						</table>
						<button (click)="DownloadData()" title="Save this table as a CSV file" class="btn btn-primary btn-sm form-control mt-3">
							Save to CSV
						</button>
					</div>
				</div>
			</div>
			<div class="item-panel">
				<div class="heading">Acknowledgement Log</div>
				<div class="content">
					<div *ngIf="logs && !logs.length">
						No acknowledgement logs have been entered
					</div>
					<div *ngIf="logs && logs.length">
						<table class="acknowledgement-list">
							<thead>
								<tr>
									<th>Date</th>
									<th>Entered by</th>
									<th>Summary</th>
									<th *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
										Delete</th>
								</tr>
							</thead>
							<tbody *ngFor="let log of logs">
								<tr>
									<td>{{log.ts | datetime : "date" }}</td>
									<td>{{log.author_email}}</td>
									<td class="truncate" [title]="log.user_note"><span>{{log.user_note}}</span></td>
									<td *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
										<app-action-button [action]="DeleteAcknowledgement" [args]="[log.vibe_check_ack_id]" [context]="this" btnClass="btn-danger btn-sm" confirm="Are you sure?"
											processing="...">x
										</app-action-button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="row mt-3">
						<div class="col-lg-8">
							<div class="form-group">
								<label>Note (optional):</label>
								<div>
									<textarea [(ngModel)]="newSummary" style="width: 100%;height: 150px;"></textarea>
								</div>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="form-group">
								<label>Log vibe check acknowledgement:</label>
								<app-action-button [action]="SaveAcknowledgement" [context]="this" processing="Saving..."
									complete="Acknowledgement recorded" btnClass="btn-success btn-block">Acknowledge</app-action-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>